/* export enum CreditStatusEnum {
    SI = "Solicitud Incompleta",
    SR = "Solicitud rechazada",
    S = "Solicitado",
    PF = "Pendiente de firmar",
    VI = "Vigente",
    EM = "En mora",
    CD = "Cupo disponible",
    D = "Desistido",
    AD = "Cancelado"
  } */

  export const CreditStatusEnum = Object.freeze({
    SI: "Solicitud Incompleta",
    SR: "Solicitud rechazada",
    S: "Solicitado",
    PF: "Pendiente de firmar",
    VI: "Vigente",
    EM: "En mora",
    CD: "Cupo disponible",
    D: "Desistido",
    AD: "Cancelado"
  });